import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, Globe2 } from 'lucide-react';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 bg-slate-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
             <div className="relative rounded-2xl overflow-hidden shadow-xl">
               <img 
                 src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
                 alt="Logistics Team" 
                 className="w-full h-auto object-cover"
               />
               <div className="absolute inset-0 bg-marine-900/20 mix-blend-multiply"></div>
             </div>
             {/* Decorative Element */}
             <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-marine-100 rounded-full -z-10"></div>
             <div className="absolute -top-6 -left-6 w-32 h-32 bg-slate-200 rounded-full -z-10 bg-opacity-50"></div>
          </div>

          {/* Content Side */}
          <div className="lg:pl-10">
            <span className="text-marine-600 font-semibold tracking-wide uppercase text-sm mb-2 block">
              {t('navbar.about')}
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">
              {t('about.title')}
            </h2>
            <h3 className="text-xl text-marine-700 font-semibold mb-6">
              {t('about.subtitle')}
            </h3>
            
            <div className="space-y-4 text-slate-600 leading-relaxed mb-8">
              <p>{t('about.desc_1')}</p>
              <p>{t('about.desc_2')}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 border-t border-slate-200 pt-8">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                   <div className="p-2 bg-marine-50 text-marine-600 rounded-lg">
                    <Globe2 className="w-6 h-6" />
                  </div>
                </div>
                <div className="text-2xl font-bold text-slate-900">15+</div>
                <div className="text-xs text-slate-500 uppercase tracking-wide mt-1">{t('about.stats.ports')}</div>
              </div>
              <div className="text-center border-l border-slate-200">
                <div className="flex justify-center mb-2">
                   <div className="p-2 bg-marine-50 text-marine-600 rounded-lg">
                    <Users className="w-6 h-6" />
                  </div>
                </div>
                <div className="text-2xl font-bold text-slate-900">500+</div>
                <div className="text-xs text-slate-500 uppercase tracking-wide mt-1">{t('about.stats.clients')}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
